export default __webpack_public_path__ + "static/lil-nadas-home-4912ef2cf08cd627ca5d84e21edf62ad.png";